import { Grid } from '@fs/zion-ui'
import React from 'react'
import DiscussionsCardSkeleton from '../cards/discussions-card/DiscussionsCardSkeleton'
import NotesCardSkeleton from '../cards/notes-card/NotesCardSkeleton'

export default function CollaborateTabSkeleton(): JSX.Element {
  return (
    <Grid gutters="nano">
      <NotesCardSkeleton />
      <DiscussionsCardSkeleton />
    </Grid>
  )
}
